import { useState } from "react";

// Logos oficiales: colocar los archivos en /public/logos/ con estos nombres:
//   isotipo.jpg   -> Logo-oficial-convencion-2026.jpg
//   logo-full.jpg -> LOGO-COMPLETO-OFICIAL.jpg
//   titulo.jpg    -> TITULO.jpg
const SRCS = {
  icon: "/logos/isotipo.jpg",
  full: "/logos/logo-full.jpg",
  title: "/logos/titulo.jpg",
};

const HorizonMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="22" fill="#2F557F" />
    <path d="M10 30h28" stroke="#67BEC7" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M14 24h24" stroke="#16A9D5" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M24 10l7 9h-5v5h-4v-5h-5l7-9z" fill="#FFFFFF" />
  </svg>
);

const TextFallback = ({ variant }) => (
  <span className="flex items-center gap-2">
    <HorizonMark className={variant === "full" ? "h-12 w-12" : "h-8 w-8"} />
    <span className="leading-none">
      <span className={`block font-extrabold tracking-tight text-hz-navy ${variant === "full" ? "text-2xl" : "text-lg"}`}>
        HORIZONTE <span className="text-hz-cyan">2026</span>
      </span>
      {variant !== "icon" && (
        <span className={`block font-semibold uppercase tracking-widest text-hz-blue ${variant === "full" ? "text-[11px]" : "text-[9px]"}`}>
          Liderazgo con Visión Reformada
        </span>
      )}
    </span>
  </span>
);

export const Logo = ({ variant = "title", className = "h-10", alt = "Horizonte 2026 — Liderazgo con Visión Reformada" }) => {
  const [failed, setFailed] = useState(false);
  if (failed) return <TextFallback variant={variant} />;
  return (
    <img
      src={SRCS[variant]}
      alt={alt}
      className={`${className} w-auto max-w-full object-contain`}
      onError={() => setFailed(true)}
      data-testid={`logo-${variant}`}
    />
  );
};
